import { render } from "./TestCompleted.vue?vue&type=template&id=504da9e2&scoped=true"
import script from "./TestCompleted.vue?vue&type=script&lang=js"
export * from "./TestCompleted.vue?vue&type=script&lang=js"

import "./TestCompleted.vue?vue&type=style&index=0&id=504da9e2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504da9e2"]])

export default __exports__